import { Controller } from "@hotwired/stimulus"

// Révèle un élément fixe (typiquement la bottom nav) une fois que
// l'utilisateur a scrollé au-delà d'un seuil (par défaut 80 px).
// L'élément doit gérer visuellement les deux états via CSS, en s'appuyant
// sur l'attribut `data-revealed="true"` posé par ce contrôleur.
//
// Usage :
//   <nav data-controller="scroll-reveal"
//        data-scroll-reveal-threshold-value="80"
//        class="opacity-0 translate-y-3 pointer-events-none transition-all duration-300 ease-out
//               data-[revealed=true]:opacity-100 data-[revealed=true]:translate-y-0
//               data-[revealed=true]:pointer-events-auto">
export default class extends Controller {
  static values = { threshold: { type: Number, default: 80 } }

  connect() {
    this.rafPending = false
    this.onScroll = this.onScroll.bind(this)
    this.update()
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onScroll)
  }

  onScroll() {
    if (this.rafPending) return
    this.rafPending = true
    requestAnimationFrame(() => {
      this.rafPending = false
      this.update()
    })
  }

  update() {
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0
    const revealed = scrollY > this.thresholdValue
    if (revealed) {
      this.element.dataset.revealed = "true"
    } else {
      delete this.element.dataset.revealed
    }
  }
}
